import styled from 'styled-components';

const PHONE_WIDTH_BREAKPOINT = 820;

export const HideOnPhoneWrapper = styled.div`
  @media (max-width: ${PHONE_WIDTH_BREAKPOINT}px) {
    display: none !important;
  }
`;
export const ShowOnPhoneWrapper = styled.div`
  @media (min-width: ${PHONE_WIDTH_BREAKPOINT + 1}px) {
    display: none !important;
  }
`;
